module.exports = __webpack_public_path__ + "img/Ubuntu.b022df2.svg";